import Radio from "../../components/Radio";

const Radios = ({
  hidden,
  name,
  value,
  label,
  checked,
  disabled,
  value2,
  label2,
  checked2,
  disabled2,
  click,
}) => {
  return (
    <div className={hidden ? "hidden" : ""}>
      {label && (
        <div
          className="form-group checkbox"
          style={{
            marginLeft: "15px",
            marginTop: "0",
            marginBottom: "5px",
          }}
        >
          <Radio
            name={name}
            value={value}
            label={label}
            checked={checked}
            disabled={disabled}
            click={click}
          />
        </div>
      )}
      <div
        className="form-group checkbox"
        style={{
          marginLeft: "15px",
          marginTop: "0",
          marginBottom: "5px",
        }}
      >
        <Radio
          name={name}
          value={value2}
          label={label2}
          checked={checked2}
          disabled={disabled2}
          click={click}
        />
      </div>
    </div>
  );
};
export default Radios;
